import { render, staticRenderFns } from "./ModalRegisterAlert.vue?vue&type=template&id=49712038&scoped=true"
import script from "./ModalRegisterAlert.vue?vue&type=script&lang=js"
export * from "./ModalRegisterAlert.vue?vue&type=script&lang=js"
import style0 from "./ModalRegisterAlert.vue?vue&type=style&index=0&id=49712038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49712038",
  null
  
)

export default component.exports